import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { IEvents as e } from "@walletconnect/events";
import c, { EventEmitter as i } from "events";
var n = /*#__PURE__*/function (_e) {
  _inherits(n, _e);
  var _super = _createSuper(n);
  function n(s) {
    var _this;
    _classCallCheck(this, n);
    _this = _super.call(this), _this.opts = s, _this.protocol = "wc", _this.version = 2;
    return _this;
  }
  return _createClass(n);
}(e);
var l = /*#__PURE__*/_createClass(function l(s, t, o) {
  _classCallCheck(this, l);
  this.core = s, this.logger = t;
});
var h = /*#__PURE__*/function (_e2) {
  _inherits(h, _e2);
  var _super2 = _createSuper(h);
  function h(s, t) {
    var _this2;
    _classCallCheck(this, h);
    _this2 = _super2.call(this), _this2.core = s, _this2.logger = t, _this2.records = new Map();
    return _this2;
  }
  return _createClass(h);
}(e);
var a = /*#__PURE__*/_createClass(function a(s, t) {
  _classCallCheck(this, a);
  this.logger = s, this.core = t;
});
var u = /*#__PURE__*/function (_e3) {
  _inherits(u, _e3);
  var _super3 = _createSuper(u);
  function u(s, t) {
    var _this3;
    _classCallCheck(this, u);
    _this3 = _super3.call(this), _this3.relayer = s, _this3.logger = t;
    return _this3;
  }
  return _createClass(u);
}(e);
var g = /*#__PURE__*/function (_e4) {
  _inherits(g, _e4);
  var _super4 = _createSuper(g);
  function g(s) {
    _classCallCheck(this, g);
    return _super4.call(this);
  }
  return _createClass(g);
}(e);
var p = /*#__PURE__*/_createClass(function p(s, t, o, w) {
  _classCallCheck(this, p);
  this.core = s, this.logger = t, this.name = o;
});
var I = /*#__PURE__*/_createClass(function I() {
  _classCallCheck(this, I);
  this.map = new Map();
});
var d = /*#__PURE__*/function (_e5) {
  _inherits(d, _e5);
  var _super5 = _createSuper(d);
  function d(s, t) {
    var _this4;
    _classCallCheck(this, d);
    _this4 = _super5.call(this), _this4.relayer = s, _this4.logger = t;
    return _this4;
  }
  return _createClass(d);
}(e);
var x = /*#__PURE__*/_createClass(function x(s, t) {
  _classCallCheck(this, x);
  this.core = s, this.logger = t;
});
var E = /*#__PURE__*/function (_e6) {
  _inherits(E, _e6);
  var _super6 = _createSuper(E);
  function E(s, t) {
    var _this5;
    _classCallCheck(this, E);
    _this5 = _super6.call(this), _this5.core = s, _this5.logger = t;
    return _this5;
  }
  return _createClass(E);
}(e);
var m = /*#__PURE__*/_createClass(function m(s, t) {
  _classCallCheck(this, m);
  this.logger = s, this.core = t;
});
var y = /*#__PURE__*/_createClass(function y(s, t) {
  _classCallCheck(this, y);
  this.projectId = s, this.logger = t;
});
var v = /*#__PURE__*/function (_c) {
  _inherits(v, _c);
  var _super7 = _createSuper(v);
  function v() {
    _classCallCheck(this, v);
    return _super7.call(this);
  }
  return _createClass(v);
}(c);
var b = /*#__PURE__*/_createClass(function b(s) {
  _classCallCheck(this, b);
  this.opts = s, this.protocol = "wc", this.version = 2;
});
var C = /*#__PURE__*/function (_i) {
  _inherits(C, _i);
  var _super8 = _createSuper(C);
  function C() {
    _classCallCheck(this, C);
    return _super8.call(this);
  }
  return _createClass(C);
}(i);
var S = /*#__PURE__*/_createClass(function S(s) {
  _classCallCheck(this, S);
  this.client = s;
});
export { n as ICore, l as ICrypto, S as IEngine, C as IEngineEvents, E as IExpirer, h as IJsonRpcHistory, x as IKeyChain, a as IMessageTracker, m as IPairing, u as IPublisher, g as IRelayer, b as ISignClient, v as ISignClientEvents, p as IStore, d as ISubscriber, I as ISubscriberTopicMap, y as IVerify };